import Message from "../../message";
import {useMainStore} from "@/store";

export default class ApplicationApproved extends Message
{
    handle()
    {
        // TODO: SHOULD THIS REMOVE ALL APPLICATIONS AND INVITES?
        useMainStore().REMOVE_APPLICATION(this.message.guild.id);
        useMainStore().SET_GUILD(this.message.guild);
    }
}
